var jquery = require("jquery");
window.$ = window.jQuery = jquery;
require('lazysizes');
import Swiper from 'swiper/bundle';

import Rellax from 'rellax';
var rellax = new Rellax('.rellax', {
    center: true
});

var SmoothScroll = require('smooth-scroll');
var scroll = new SmoothScroll('body a[href*="#"]', {
	updateURL: false,
	easing: 'easeInOutSine',
	speed: 150
});



var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.headerContainer').outerHeight();

var sliderCircles = Swiper;
var sliderCirclesInit = false;

// READY

$(function () {

	console.log('Website proudly by Imagic Creative');
	
	// setInterval(() => {
	// 	$("[data-required]").each(function (index) {
	// 		$(this).attr('required', true);
	// 	});
	// }, 300);

	var scroll = $(window).scrollTop();
	
    if (scroll > navbarHeight) {
		$('header').addClass('nav-down');
	}

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		} else if ($(window).scrollTop() < 5) {
			$('header').removeClass('nav-up').removeClass('nav-down');
		}
	}, 250);

	if ($('.circles-slider').length) {
		circlesSliderInit();
	}

	// Initialize golden cards animation
	initGoldenCardsAnimation();

	initSectionReveals();

	initHomeHeadingReveal();

	
	// var iframe = $('#myIframe');

	// // Function to adjust the iframe height
	// function adjustIframeHeight(height) {
	//   iframe.height(height);
	// }

	// // Attach message event listener
	// window.addEventListener('message', function(event) {
	// 	console.log(event)
	//   if (event.data.type === 'resizeIframe') {
	// 	adjustIframeHeight(event.data.height);
	//   }
	// });

});


// SCROLL

$(window).on('scroll', function(e) {

	didScroll = true;

});



// RESIZE

$(window).on('resize', function() {

	if ($('.circles-slider').length) {
		circlesSliderInit();
	}

});






function hasScrolled() {

	if ($('body.mobile-menu-open').length) {
		$('header').removeClass('nav-up').addClass('nav-down');
		return;
	}
    var st = $(window).scrollTop();

    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.

    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        if ($('header').hasClass('nav-down')) {
            $('header').removeClass('nav-down').addClass('nav-up');
        }
    } else {
        // Scroll Up
        if(st > navbarHeight && (st + $(window).height() < $(document).height())) {
            $('header').removeClass('nav-up').addClass('nav-down');
        } 
		var topOffset = 5;

        if(st < topOffset) {
            $('header').removeClass('nav-up').removeClass('nav-down');
        }
    }
    
    lastScrollTop = st;
} 




function circlesSliderInit() {
    let mobile = window.matchMedia('(max-width: 1279px)');
    let desktop = window.matchMedia('(min-width: 1280px)');
	// let sliderCirclesInit = [];
	// let sliderCircles = [];
	
	if(mobile.matches) {
		if (!sliderCirclesInit) {
			sliderCirclesInit = true;
			$('.circles-slider').each(function(i) {
				// Enable (for mobile)
				sliderCircles = new Swiper($(this)[0], {
					slidesPerView: 1,
					spaceBetween: 16,
					autoResize: false,
					speed: 600,
					navigation: false,
					autoplay: false,
					scrollbar: false,
					pagination: {
						el: '.swiper-pagination',
						type: 'bullets'
					},
					loop: false,
					touchEventsTarget: 'wrapper',
					centeredSlides: false,
					breakpoints: {
						768: {
							slidesPerView: 2,
						},
						1280: {
							slidesPerView: 3,
						},
					},
				});
			});
		}

	}

	// Disable (for desktop)
	else if(desktop.matches) {
		try {
			$('.circles-slider').each(function(i) {
				const circles = this.swiper;
				circles.destroy(true, true);
			});
		} catch(err) {
			// alert("err");
		}
		sliderCirclesInit = false;
	}
}





$('.hamburger').on("click", function(e) {
	e.stopPropagation();
	$(this).toggleClass('open');
	$('aside').toggleClass('open');
	$('.headerContainer').add('body').toggleClass('mobile-menu-open');
	if ($(window).scrollTop() > 0) {
		$('header').addClass('nav-down');
	}
	if ($(this).hasClass('open')) {
		$(this).attr('aria-expanded', true);
	} else {
		$(this).attr('aria-expanded', false);
	}
});
$('aside a').on("click", function(e) {
	e.stopPropagation();
	$('.hamburger').trigger('click');
});


// Golden Cards Animation
function initGoldenCardsAnimation() {
	const goldenCardsContainer = document.querySelector('.golden-cards');
	
	if (!goldenCardsContainer) return;
	
	// Create intersection observer
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				// Get all card images
				const cards = entry.target.querySelectorAll('img');
				
				// Animate all cards except the first one (process from last to first)
				cards.forEach((card, index) => {
					if (index > 0) {
						// Calculate reverse index (from last to first)
						const reverseIndex = cards.length - index;
						// Increment angle by 5 degrees for each card (negative for counter-clockwise)
						const angle = reverseIndex * -10; // -20°, -15°, -10°, -5° for cards 2, 3, 4, 5
						const delay = (reverseIndex - 1) * 0.1; // Staggered delay: 0.3s, 0.2s, 0.1s, 0s
						
						// Apply CSS transition and transform
						card.style.transition = `transform 0.8s ease-out ${delay}s`;
						card.style.transform = `rotate(${angle}deg)`;
					}
				});
				
				// Unobserve after animation to prevent re-triggering
				observer.unobserve(entry.target);
			}
		});
	}, {
		threshold: 0.3, // Trigger when 30% of the element is visible
		rootMargin: '0px 0px -50px 0px' // Start animation slightly before element is fully in view
	});
	
	// Start observing
	observer.observe(goldenCardsContainer);
}

/**
 * Hero h1: wrap each character (preserves <br> from nl2br), staggered rise + subtle bounce via CSS.
 */
function initHomeHeadingReveal() {
	var h1 = document.querySelector('#home h1.home-heading-reveal');
	if (!h1 || h1.dataset.headingRevealInit === '1') {
		return;
	}

	var label = h1.textContent.replace(/\s+/g, ' ').trim();
	if (!label) {
		return;
	}

	h1.setAttribute('aria-label', label);

	var charIndex = 0;

	function processNode(parent) {
		Array.prototype.slice.call(parent.childNodes).forEach(function (child) {
			if (child.nodeType === Node.TEXT_NODE) {
				var text = child.textContent;
				if (!text) {
					return;
				}
				var frag = document.createDocumentFragment();
				for (var j = 0; j < text.length; j++) {
					var ch = text[j];
					if (ch === ' ' || ch === '\n' || ch === '\r' || ch === '\t') {
						frag.appendChild(document.createTextNode(ch === '\t' ? ' ' : ch));
						continue;
					}
					var span = document.createElement('span');
					span.className = 'home-heading-reveal__char';
					span.textContent = ch;
					span.style.setProperty('--char-index', String(charIndex));
					charIndex++;
					frag.appendChild(span);
				}
				parent.replaceChild(frag, child);
			} else if (child.nodeType === Node.ELEMENT_NODE && child.tagName !== 'BR') {
				processNode(child);
			}
		});
	}

	var inner = document.createElement('span');
	inner.className = 'home-heading-reveal__inner';
	inner.setAttribute('aria-hidden', 'true');

	while (h1.firstChild) {
		inner.appendChild(h1.firstChild);
	}
	h1.appendChild(inner);
	processNode(inner);

	h1.classList.add('home-heading-reveal--ready');
	h1.dataset.headingRevealInit = '1';
}

function initSectionReveals() {
	// if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
	// 	document.querySelectorAll('.section-reveal').forEach(function (el) {
	// 		el.classList.add('is-visible');
	// 	});
	// 	return;
	// }

	document.querySelectorAll('.section-reveal').forEach(function (el) {
		var observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						entry.target.classList.add('is-visible');
						observer.unobserve(entry.target);
					}
				});
			},
			{ threshold: 0.12, rootMargin: '0px 0px -32px 0px' }
		);
		observer.observe(el);
	});
}


